import { render } from "./NvXueshengPage.vue?vue&type=template&id=6b5cbe9d&scoped=true"
import script from "./NvXueshengPage.vue?vue&type=script&lang=js"
export * from "./NvXueshengPage.vue?vue&type=script&lang=js"

import "./NvXueshengPage.vue?vue&type=style&index=0&id=6b5cbe9d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5cbe9d"]])

export default __exports__